import { Menu, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";

export default function Dropdown({ title, children }) {
  return (
    <div className="">
      <Menu as="div" className="md:relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex border border-gray-400 hover:bg-[#F4F4F4] w-full justify-center rounded-md px-4 py-2 text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            {title}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            static
            className="absolute max-h-[270px] overflow-y-auto menu_sc right-0 z-40 left-0  md:min-w-[208px] origin-top-right divide-y divide-gray-100  bg-white rounded-lg  ring-1 ring-black ring-opacity-5 shadow-xl focus:outline-none"
          >
            <div className="px-1 py-1 ">
              <Menu.Item>
                {({ active }) => (
                  <div
                    className={`${
                      active ? "" : "text-gray-900"
                    } group flex w-full items-center rounded-md text-sm`}
                  >
                    {children}
                  </div>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
